
// Contains route path constants


export const routes = {
  Home: `/`,
  Login: `/login`,

  //Pages
  Sample: `/sample-page`,

  //Other
  ErrorPages: {
    Error404: `/error-pages/error-404`,
  },

  //users
  Users:  `/users`,
  UserRegister: `/user-register`,
  UpdateUser: `/update-user/:Id`,
  UpdatePassword: `/update-password/:Id`,
  UserProfilePage: `/user-profile-page/:Id`,

  
  //Distributary Zone
  DistributaryZoneUpdate: `/distributary-zone-update/:Id`,
  DistributaryZoneForm: `/distributary-zone-form`,
  DistributaryZoneList: `/distributary-zone-list`,

  //Scheme Village
  SchemeVillageAdd: `/scheme-village-Add`,
  SchemeVillageList: `/scheme-village-list`,
  SchemeVillageUpdate: `/scheme-village-update/:Id`,

  //Chack
  ChackList: `/chack-list`,
  ChackUpdate: `/chack-update/:Id`,
  ChackAdd: `/chack-add`,

  ChackInstrument: `/chack-instrument`,
  ChackInstrumentUpdate: `/chackinstrument-update/:Id`,
  AddChackInstrument: `/add-chack-instrument`,

  //Email
  EmailList: `/email-list`,
  EmailUpdate: `/email-update/:Id`,
  AddEmail: `/add-email`,

  //Chack Valve Detail
  ChackValveDetail: `/chack-valve-detail`,
  UpdateChackValveDetail: `/update-chack-valve-detail/:Id`,
  AddChackValveDetail: `/add-chack-valve-detail`,

  //Khasara
  KhasaraList: `/khasara-list`,
  KhasaraUpdate: `/khasara-update/:Id`,
  AddKhasara: `/add-khasara`,

  //Farmer
  FarmerList: `/Farmer-list`,
  FarmerUpdateL:`/farmer-update/:Id`,
  AddFarmer: `/add-farmer`,

  //Kml
  KmlList: `/kml-List`,
  AddKml:  `/add-kml`,
  UpdateKml:`/update-kml/:id`,

  MapView: `/map-view`,
  PopUp : `/popup`,

  //project
  ProjectList : `/project-list`,
  ProjectUpdate:`/project-update/:id`,
  ProjectAdd :`/project-add`,

  //Oms
  OmsList : `/oms-list`,
  OmsUpdate : `oms-update/:id`,
  OmsAdd :`oms-add`,
  
  //Dashboard

  DashBoard : `/dashboard`,

  //Reset-password

  ResetPassword:`/reset-password` ,

  //Emailsender
   EmailSender:`/email-sender`,

   MqttPage:`mqtt`,

   //report 

    report :`report`,

    //calendar

    Calendar : `calendar`,

    //
    Alarms: `alarms`,

    //
    BeneficiaryList:`/beneficiary-list`,
    BeneficiaryUpdate:`/beneficiary-update/:Id`,
    BeneficiaryAdd:`/beneficiary-add`,
    

    PumpingStationList:`/pumpingstation-list`,
    PumpingStaionAdd: `/pumpingstation-add`,
    PumpingStationUpdate:`/pumpingstation-update/:Id`,

    AddPumpingStationHistory : `/pumping-history-add`,
    UpdatePumpingStationHistory:`/pumping-history-update/:Id`,
    Trends:`/trends`,

    GetReportPumpingStation:`/get-report-pumping-station`,

    AddPowerConsumption:`/power-consumption-add`,
    UpdatePowerConsumption:`/power-consumption-update/:Id`,
    PowerConsuumption:`/power-consumption`,

    Group:`/group-list`,
    AddGroup:`/add-group`,
    UpdateGroup:`/update-group/:Id`,

    AddChakInGroup:`/chak-in-group`,
    ViewEditChak:`/view-edit-chak/:Id`,

    GroupScheduler:`/group-scheduler`,
    ScheduleStatus:`/schedule-status`,

    WuaList:`/wua-list`,
    AddWua:`/add-wua`,
    WuaUpdate:`/update-wua/:Id`,

};

export default routes;